import React, {Component} from 'react';

import Tree from 'react-animated-tree'
import axios from "axios";
import TreeMenu, { defaultChildren, ItemComponent } from 'react-simple-tree-menu';
import { ListGroupItem, Input, ListGroup } from 'reactstrap';

export default class UserView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            userViewInfo: [],
            userNodeInfo: [],
            individualUserViewInfo: [],
            clickedUserId: '',
            userDetails: [],
            userRoleDetails: [],
            userAssignmentDetails: [],
            activeTab: '',
            currentUserId:'',
            expandedChildName: ''
        };
    }


    hideLoader = () => {
        this.setState({loading: false })
        this.props.onUpdate(this.state)
    }

    showLoader = () => {
        this.setState({ loading: true });
    }
    componentDidMount() {
                this.showLoader();
        axios.get(`getLoggedUserName?JSESSIONID=${sessionStorage.getItem('COOKIE')}`)
            .then(response => {

                this.setState({ loggedInUser: response.data })
                console.log("=== LOG_1 === Inside componentDidMount %s with data ","User View",this.state.loggedInUser);

                axios.get('getUserViewList?id='+this.state.loggedInUser,{
                    headers: {"Access-Control-Allow-Origin": "*"}})
                    .then(response => {
                        this.setState({ userViewInfo: response.data.response,loading: false })
                    }).finally(()=> {
                    // this.hideLoader();
                }).catch(error => {
                        console.log("GOT ERROR HERE for Get User View ",error);
                    });


                //get default Logged in user import change this after logged in user implementtion
                axios.get('getUserInfoById?id='+this.state.loggedInUser,{
                    headers: {"Access-Control-Allow-Origin": "*"}})
                    .then(response => {
                        this.setState({ userDetails: response.data.response,loading: false })

                        //user this below function to update state between elements
                        this.props.onUpdate(this.state)
                        //this.hideLoader();
                    }).finally(()=> {
                    this.hideLoader();
                })
                    .catch(error => {
                        console.log("Exception Thrown::{get User Info by Administartor}",error);
                    });

                //get Roles by ID
                axios.get('getUserRoleById?id='+this.state.loggedInUser, {
                    headers: {"Access-Control-Allow-Origin": "*"}})
                    .then(response => {
                        this.setState({ userRoleDetails: response.data.response,loading: false })
                        this.props.onUpdate(this.state)
                    }).finally(()=> {
                    this.hideLoader();
                })
                    .catch(error => {
                        console.log("Exception Thrown::{ get userRoleDetails by ID}",error);
                    });




            }).finally(()=> {
            // this.hideLoader();
        })
            .catch(error => {
                console.log("GOT ERROR HERE for Get LoggedIn User",error);
            });



    }

    retreiveUserRoleById(id) {
        this.showLoader()
        //id = ''
        console.log('Retrieving Details for: ', id)


        axios.get('getUserInfoById?id='+id,{
            headers: {"Access-Control-Allow-Origin": "*"}})
            .then(response => {
                this.setState({ userDetails: response.data.response,loading: false })
                //user this below function to update state between elements
                this.setState({selectedList: ['']})
                this.setState({accountLHSListDual:['']})
                this.setState({terminalLHSListDual:['']})
                this.setState({accountRHSListDual:['']})
                this.setState({terminalRHSListDual:['']})
                this.setState({ clickedUserId: id })
                this.props.onUpdate(this.state)
            }).finally(()=> {
            this.hideLoader();
            })
            .catch(error => {
                console.log("Exception Thrown::{get User Info by ID}",error);
            });

        //get Info for Roles
        axios.get('getUserRoleById?id='+id,{
            headers: {"Access-Control-Allow-Origin": "*"}})
            .then(response => {
                this.setState({ userRoleDetails: response.data.response,loading: false })
                //user this below function to update state between elements
                this.props.onUpdate(this.state)
            }).finally(()=> {
            this.hideLoader();
            })
            .catch(error => {
                console.log("Exception Thrown::{ get userRoleDetails by ID}",error);
            });

        //Get info for assignments

    }



     action(event, nodeId) {
         this.retreiveUserRoleById(nodeId)
    }

    getNode(event, props) {
        this.showLoader();
        console.log(" Retrieving user info for ... ",props.currentTarget.offsetParent.innerText)
        this.expandedChildName = props.currentTarget.offsetParent.innerText.match("\\b(?!(?:end\\b))[\\w]+")[0]
        if(props.currentTarget.offsetParent.innerText.includes("+")){
            axios.get('getUserViewList?id='+props.currentTarget.offsetParent.innerText.match("\\b(?!(?:end\\b))[\\w]+")[0],{
                headers: {"Access-Control-Allow-Origin": "*"}})
                .then(response => {
                    this.setState({ userNodeInfo: response.data.response,loading: false })
                }).finally(()=> {
                this.hideLoader();
            }).catch(error => {
                console.log("GOT ERROR HERE for Get User View ",error);
            });
        }

    }

    render() {

        const usrImageStyle = {
            width: '14px',
            margin: '0px 0px 0px 0px'
        }
        const SingleUserIcon = ({ on }) => <span onClick={({ key, label, ...props }) => {this.getNode(this,props);}}  style={{ marginRight: 8 }}>{on ? '' : ''} <img style={usrImageStyle} src="assets/images/icons/users.gif"/></span>;
        const ToggleIcon = ({ on }) => <span onClick={({ key, label, ...props }) => {this.getNode(this,props);}} style={{ marginRight: 8 }}>{on ? '-..' : '+..'} <img style={usrImageStyle} src="assets/images/icons/users.gif"/></span>;
        const ListItem = ({
                              level = 0,
                              hasNodes,
                              isOpen,
                              label,
                              searchTerm,
                              openNodes,
                              toggleNode,
                              getNode,
                              matchSearch,
                              key,
                              focused,
                              ...props
                          }) => (
            <ListGroupItem
                {...props}
                style={{
                    cursor: 'pointer',
                    boxShadow: focused ? '0px 0px 5px 0px #222' : 'none',
                    zIndex: focused ? 999 : 'unset',
                    position: 'relative',
                    padding: '0.3rem 0.6rem',
                }}>
                {hasNodes && (
                    <div
                        style={{ display: 'inline-block', }}
                        onClick={e => {
                            hasNodes && toggleNode && toggleNode();
                            e.stopPropagation();
                        }}
                    >
                        <ToggleIcon on={isOpen} id={key}  />
                    </div>
                )}
                {!hasNodes && (
                    <div
                        style={{ display: 'inline-block', padding: '0.3rem 1.6rem' }}
                        onClick={e => {
                            hasNodes && toggleNode && toggleNode();
                            e.stopPropagation();
                        }}
                    >
                        <SingleUserIcon on={isOpen}  />
                    </div>
                )

                }
                {label}
            </ListGroupItem>
        );






        /** Find logic to iterate from parent to child internally
         **/


        let childComponentsNode = this.state.userNodeInfo.map((i) =>{
            if(i.childNodeCount<1) {
                return {
                    key: i.userId,
                    label: i.userId,
                    url: i.userId,
                };
            }else if(i.childNodeCount>0){
                return {
                    key: i.userId,
                    label: i.userId,
                    url: i.userId,
                    nodes:  [{
                        key: i.userId,
                        label: i.userId,
                        url: i.userId,
                    }]

                };
            }
        });



        const data = this.state.userViewInfo.map((i) =>{
            if(i.childNodeCount<1) {
                return {
                    key: i.userId,
                    label: i.userId,
                    url: i.userId,
                };
            }else if(i.childNodeCount>0){
                return {
                    key: i.userId,
                    label: i.userId,
                    url: i.userId,
                    nodes: [{
                        key: i.userId,
                        label: i.userId,
                        url: i.userId,
                    }]
                };
            }
        });

        var currrentNodeId=0;
        const item =
            [{
                key: sessionStorage.getItem('UserName'),
                label: sessionStorage.getItem('UserName'),
                url: sessionStorage.getItem('UserName'),
                nodes: data
            }];


        //iterate over objects to get index for child been clicked to retrieve its child elements
        Object.keys(item).map((innerAttr) => {
            currrentNodeId = item[innerAttr].nodes.map((e,i) =>(e.key === this.expandedChildName)  ? i : undefined).filter(x => x)[0]
            /*if (typeof data !== 'undefined') {
                Object.keys(data).map((innerAttr) => {
                    console.log("child node", data[innerAttr].nodes.map((e, i) => (e.key === this.expandedChildName) ? i : undefined).filter(x => x)[0])
                });
            }*/
        });

        //console.log(currrentNodeId," ====== childComponentsNode ",childComponentsNode)
        //Append child elements of clicked +.. name parent
        if (typeof data[currrentNodeId] !== 'undefined'){
            //console.log(data[currrentNodeId]['nodes'][0][currrentNodeId])
            childComponentsNode.forEach(o=>data[currrentNodeId]['nodes'].push(o))

            //if there is child node dont delete it
            delete data[currrentNodeId]['nodes'][0]

        }
          return  <div className="col-xl-3 card">
            <div className="card cardoveride">
                <div className="card-body">
                    <h4 className="card-title mb-2 pb-2">User Allotments</h4>
                    <div className="mb-4">
                        <TreeMenu initialOpenNodes={[sessionStorage.getItem('UserName')]}
                                  initialActiveKey={sessionStorage.getItem('UserName')} style={{ padding: '12px', background: 'black' }} onClickItem={({ key, label, ...props }) => {
                             this.action(this,props.url); // user defined prop
                        }}  data={item} debounceTime={125} resetOpenNodesOnDataUpdate={false} >
                            {({ search, items,resetOpenNodes}) => (
                                <>
                                    <button  type="button" class="btn btn-outline-primary btn-sm" style={{ float: 'right', marginBottom: '10px', width :'100%' }}
                                        onClick={() => {
                                            resetOpenNodes(['ImagicATM']);
                                        }}
                                    >
                                        Reset User Selection
                                    </button>
                                    <Input onChange={e => search(e.target.value)} placeholder="search for User ..." />
                                    <ListGroup>
                                        {items.map(({ reset, ...props }) => (
                                            <ListItem  {...props}/>

                                        ))}
                                    </ListGroup>
                                </>
                            )}
                        </TreeMenu>


                    </div>
                </div>
            </div>
        </div>;

        }
    }